<template>
  <card class="card">
    <template slot="header">
      <div class="d-flex">
        <div class="mr-auto p-2"><h4 class="card-title">{{ $t('accountCardDetails.title') }}</h4></div>
        <account-card-replace-btn :account-id="accountId" v-if="data && data.type !== 'EMV' && $auth.can({account_card: 'update'}, 'permissions')"/>
        <base-button type="neutral" size="sm" icon round class="zi_100 ml-2" @click="fullShow = !fullShow">
          <span
            :class="{'mdi_icon':true, 'mdi':true, 'mdi-18px':true, 'mdi-unfold-more-horizontal':!fullShow, 'mdi-unfold-less-horizontal':fullShow}"/>
        </base-button>
      </div>
    </template>
    <span v-if="data">
      <card-details-view :details="data" :full-show="fullShow" class="striped_table w-100"/>
    </span>
  </card>
</template>
<script>
import {mapActions, mapState} from "vuex";
import CardDetailsView from "../../Card/CardDetailsView";
import AccountCardReplaceBtn from "@/pages/Account/AccountDetails/AccountCardReplaceBtn";

export default {
  name: "AccountCardDetails",
  components: {
    AccountCardReplaceBtn,
    CardDetailsView
  },
  props: {
    accountId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      fullShow: false
    };
  },
  computed: {
    ...mapState({
      loading: state => state.card.loading,
      error: state => state.card.error,
      data: state => state.card.data,
    }),
  },
  methods: {
    ...mapActions(['LoadCard']),
  },
  mounted() {
    this.LoadCard({id: this.accountId, byAccountId: true})
  },
};
</script>
<style></style>
